import { ContentObjectDetail } from '../content-object-detail';
import { usePostQuery } from '../queries';

type P = {
  postId: string;
};

const PostDetail = ({ postId }: P) => {
  const { data: contentObject, isLoading } = usePostQuery(postId);

  return <ContentObjectDetail contentObject={contentObject} isLoading={isLoading} />;
};

export default PostDetail;
